export default __webpack_public_path__ + "static/media/img-401.c0a2e103.jpg";